<div class="tooltip radius-m primary-bg black-text px-2 py-2 content-m tooltip-shadow" [ngClass]="['tooltip--'+position, 'tooltip--'+theme]" [class.tooltip--visible]="visible" [style.left]="left + 'px'" [style.top]="top + 'px'">
    {{tooltip}}
</div>